import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import HorizontalStepper from "./HorizontalStepper";
import AlternativeLabelStepper from "./AlternativeLabelStepper";
import ErrorStep from "./ErrorStep";
import VerticalStepper from "./VerticalStepper";
import TextStepper from "./TextStepper";
import DotStepper from "./DotStepper";
import ProgressStepper from "./ProgressStepper";

const StepperPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Stepper"}
        description={
          "Steppers convey progress through numbered steps. It provides a wizard-like workflow."
        }
      />
      <Divider light />

      <HorizontalStepper />
      <AlternativeLabelStepper />
      <ErrorStep />
      <VerticalStepper />
      <TextStepper />
      <DotStepper />
      <ProgressStepper />
    </Paper>
  );
};

export default StepperPage;
